import { Button } from '@/shared/ui';
import MessageIcon from '@/assets/icons/message-fill-primary.svg';

interface IProps {
    onAction: (back?: boolean) => void;
}

const EmailTrouble = ({ onAction }: IProps) => {
    return (
        <div className="flex flex-col gap-7" data-testid="email-having-trouble-container">
            <div className="flex flex-col items-center gap-3 md:gap-7">
                <img src={MessageIcon} alt="" />
                <div className="flex flex-col items-center gap-4">
                    <h4 className="font-agrandir text-2xl md:text-36" data-testid="email-having-trouble-title">Having Trouble?</h4>
                    <p data-testid="email-having-trouble-content" className="w-[357px] max-w-full px-5 text-center font-dmSans text-17 md:text-xl xs:px-0">
                        If you’re having trouble verifying via text message{' '}
                        <strong>we can send a code to your email instead instead.</strong>
                    </p>
                </div>
            </div>
            <div className="flex flex-col gap-2.5 md:gap-4">
                <Button testId="button-trouble-email-instead" showEndIcon onClick={() => onAction()}>
                    Email My Code Instead
                </Button>
                <Button testId="button-trouble-have-code" variant="outlined" onClick={() => onAction(true)}>
                    I Already Have My Code
                </Button>
            </div>
        </div>
    );
};

export default EmailTrouble;
